import React, { useCallback, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import Subcategories from "./Subcategories";
import clsx from "clsx";
import { trackMainNavEvent } from "../../analytics";
var useStyles = makeStyles(function () {
    return createStyles({
        wrapper: {
            display: "grid",
            gridAutoFlow: "column",
            gridGap: "24px",
            height: "100%",
            padding: 0,
        },
        category: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            height: 80,
            fontSize: 0,
            color: "#fff",
            cursor: "pointer",
            userSelect: "none",
            whiteSpace: "nowrap",
        },
        link: {
            display: "inline-block",
            fontSize: "16px",
            lineHeight: "80px",
            letterSpacing: 0.3,
            outline: "none",
            "&:hover, &:focus, &.active": {
                fontWeight: "bold",
                letterSpacing: "normal",
                textShadow: "0 0 #fff",
                WebkitFontSmoothing: "subpixel-antialiased",
            },
            "&::before": {
                display: "block",
                content: "attr(data-title)",
                visibility: "hidden",
                overflow: "hidden",
                height: 0,
                fontWeight: "bold",
                letterSpacing: 0.3,
            },
        },
    });
});
var Categories = function (_a) {
    var categories = _a.categories;
    var styles = useStyles();
    var _b = useState(false), showDropdown = _b[0], setShowDropdown = _b[1];
    var _c = useState([]), subcategories = _c[0], setSubcategories = _c[1];
    var handleMouseEnter = useCallback(function (links) {
        setShowDropdown(true);
        setSubcategories(links);
    }, []);
    var initialActive = categories &&
        categories.findIndex(function (category) {
            return (category.links &&
                category.links.some(function (item) { return item.regex && RegExp(item.regex, "i").test(window.location.href); })) ||
                (category.regex && RegExp(category.regex, "i").test(window.location.href));
        });
    return (React.createElement("ul", { className: styles.wrapper }, categories.map(function (_a, index) {
        var name = _a.name, url = _a.url, links = _a.links;
        return (React.createElement("li", { key: index, className: styles.category, onMouseEnter: function () { return handleMouseEnter(links); }, onMouseLeave: function () { return setShowDropdown(false); } },
            React.createElement("a", { href: url, className: clsx(styles.link, { active: initialActive === index }), id: "headerNavigation" + name.replace(/\s*\W*/g, ""), onClick: function () { return trackMainNavEvent(name, url); }, "data-title": name, tabIndex: 0 }, name),
            subcategories && links === subcategories && showDropdown && React.createElement(Subcategories, { subcategories: subcategories })));
    })));
};
export default Categories;
